/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_EpisodesInputs */

const en_fw_guide_stat_episodes = /** @type {(inputs: Fw_Guide_Stat_EpisodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Episodes listed`)
};

const zh_fw_guide_stat_episodes = /** @type {(inputs: Fw_Guide_Stat_EpisodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排期站列出的话数`)
};

/**
* | output |
* | --- |
* | "Episodes listed" |
*
* @param {Fw_Guide_Stat_EpisodesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_episodes = /** @type {((inputs?: Fw_Guide_Stat_EpisodesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_EpisodesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_episodes(inputs)
	return zh_fw_guide_stat_episodes(inputs)
});
export { fw_guide_stat_episodes as "fw.guide.stat.episodes" }